<template>
  <div class="layout">
    <WaterMark />
    <suspense>
      <main>
        <slot />
      </main>
    </suspense>
  </div>
</template>
<script setup lang="ts">
const route = useRoute()
</script>
